import { render, staticRenderFns } from "./HomeSettingsFiles.vue?vue&type=template&id=0b150f14"
import script from "./HomeSettingsFiles.vue?vue&type=script&lang=js"
export * from "./HomeSettingsFiles.vue?vue&type=script&lang=js"
import style0 from "./HomeSettingsFiles.vue?vue&type=style&index=0&id=0b150f14&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports